// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

/* Base styles used by Scratch https://github.com/LLK/scratch-www/blob/develop/src/main.scss */

h1,
h2,
h3,
h4,
h5,
p {
    margin: 0;
    padding: 0;
    border: 0;
}

h1,
h2,
h3,
h4,
h5 {
    font-weight: bold;
    line-height: 1.7em;
}

h1 {
    font-weight: 2.5rem;
}

h2 {
    font-weight: 2rem;
}

h3 {
    font-size: 1.4rem;
}

h4 {
    font-size: 1rem;
}

a {
    color: var(--link-color);
    cursor: pointer;
    text-decoration: underline;
}

.interface_container_uYA1D {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-width: -webkit-fit-content;
    min-width: -moz-fit-content;
    min-width: fit-content;
    background-color: var(--page-background);
}

.interface_editor_lI2gX {
    height: 100%;
}

.interface_editor_lI2gX .interface_center_rSxMk {
    height: 100%;
}

.interface_editor_lI2gX .interface_wrapper-regulator_I3Lbn {
    height: 100%;
}

.interface_player-only__MGmB .interface_center_rSxMk {
    margin: 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
    background: var(--ui-primary);
    margin: 0px;
    padding: 0.5rem;
    min-width: calc(100% - 1rem);
}

.interface_main-section_wleeI {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.interface_section_sBMjS {
    width: 480px;
    background: var(--ui-white);
    margin: 0px;
    padding: 0.5rem;
    border-radius: 0.5rem;
    border: 0.0625rem solid var(--ui-black-transparent);
}

.interface_project-related-container_Fc4M5 {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 0 0 auto;
    order: 1;
}

.interface_project-related-section_lOqHj {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
}

.interface_project-related-section_lOqHj[hidden] {
    display: none;
}

.interface_project-related-header_gdRnc {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.interface_project-related-view-all_crNoS {
    display: inline-block;
    color: var(--link-color);
    cursor: pointer;
    text-decoration: underline;
    margin: 0;
}

.interface_project-related-grid_dFhVB {
    display: flex;
    overflow-x: auto;
    border: 0.0625rem solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    padding: 0.5rem;
    gap: 0.5rem;
}

.interface_project-related-card_sTCen {
    box-sizing: border-box;
    border: 0.0625rem solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    overflow: hidden;
    cursor: pointer;
    background-color: var(--ui-secondary);
    width: 12rem;
    min-width: 12rem;
    min-height: 12rem;
}

.interface_project-related-studio-card_Fv3xX {
    box-sizing: border-box;
    border: 0.0625rem solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    overflow: hidden;
    cursor: pointer;
    background-color: var(--ui-secondary);
    width: 14rem;
    min-width: 14rem;
    min-height: 12rem;
}

.interface_project-related-thumb-wrapper_rRgIV img {
    aspect-ratio: 4 / 3;
    width: 100%;
    background: #f3f4f6;
}

.interface_project-related-studio-thumb-wrapper_IcQML img {
    aspect-ratio: 3 / 2;
    width: 100%;
    background: #f3f4f6;
}

.interface_project-related-info_nDzrf {
    padding: 0.75rem;
}

.interface_project-related-info_nDzrf h4 {
    margin: 0 0 0.5rem 0;
}

.interface_project-related-info_nDzrf p {
    font-size: 0.85rem;
    color: #4b5563;
    margin: 0;
}

.interface_project-credit_NDLn6 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    width: calc(480px - 1rem);
    padding: 0.75rem 1rem;
    text-align: left;
}

.interface_footer_dLhK2 {
    padding: 10px 0;
    border-top: 2px solid var(--ui-black-transparent);
}

.interface_footer_dLhK2 a {
    font-weight: bold;
    text-decoration: none;
}

.interface_footer-content_KvTod {
    max-width: 600px;
    margin: auto;
}

.interface_footer-text_kFpVx {
    text-align: center;
    margin: 5px 0 10px 0;
}

.interface_footer-columns_tcZeb {
    display: flex;
    justify-content: center;
    justify-items: center;
    flex-wrap: wrap;
}

.interface_footer-section_FdP5t {
    display: flex;
    flex-direction: column;
    width: 200px;
    margin-bottom: 10px;
}

.interface_footer-section_FdP5t > * {
    margin-bottom: 10px;
}

.interface_infobox_AbZXo {
    line-height: 1.5em;
    padding: 0.5rem;
    margin: 5px 0 8px 0;
    border-radius: 0.5rem;
    border: 1px solid #b9d6ff;
    background-color: #dbebff;
}

.interface_infobox_AbZXo p {
    margin: 4px 0;
}

.interface_infobox_AbZXo a {
    font-weight: bold;
    text-decoration: none;
}

.interface_unshared-update_wZeR8 {
    border-color: #ff52526e;
    background-color: #ff525240;
}

.interface_tab-list_wzzLc {
    display: flex;
    align-items: flex-end;
    flex-shrink: 0;
    flex-wrap: wrap;
    gap: 0.25rem;
    padding: 0.25rem;

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 0.80rem;

    /* Overrides for react-tabs styling */
    margin: 0 !important;
    border-bottom: 0 !important;

    color: var(--text-primary);
}

.interface_tab_n50zb.interface_is-disabled_dSNZp {
    display: none;
}

.interface_tab_n50zb {
    height: calc(2.25rem * 0.9);
    margin-bottom: 0;

    border-radius: 1rem 1rem 0.5rem 0.5rem;
    border: 1px solid var(--ui-black-transparent);

    padding: 0.125rem 1.25rem 0;
    font-size: 0.75rem;

    background-color: var(--ui-tertiary);
    color: var(--ui-text-primary-transparent);

    display: flex;
    justify-content: center;
    align-items: center;

    -webkit-user-select: none;

       -moz-user-select: none;

        -ms-user-select: none;

            user-select: none;
    white-space: nowrap;
}

.interface_tab_n50zb:hover {
  background-color: var(--ui-primary);
}

.interface_tab_n50zb.interface_is-selected_sX9wX {
    height: 2.25rem;
    color: var(--looks-secondary);
    background-color: var(--ui-white);
}

.interface_tab_n50zb img {
    width: 1.375rem;
    filter: grayscale(100%);
}

[dir="ltr"] .interface_tab_n50zb img {
    margin-right: 0.125rem;
}

[dir="rtl"] .interface_tab_n50zb img {
    margin-left: 0.125rem;
}

.interface_tab_n50zb.interface_is-selected_sX9wX img {
    filter: none;
}

/* Tab style overrides from react-tabs */

.interface_tab_n50zb.interface_is-selected_sX9wX:after {
    display: none;
}

.interface_tab_n50zb.interface_is-selected_sX9wX:focus {
    outline: none;
    box-shadow: none;
    border-color: var(--ui-black-transparent);
}

.interface_tab_n50zb.interface_is-selected_sX9wX:focus:after {
    display: none;
}

/* Body of the tabs */

.interface_tabs_cPLS6 {
    width: calc(480px + 1rem + 0.125rem);
    position: relative;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.interface_tab-panel__8HLa {
    position: relative;
    flex-grow: 1;
    display: none;
}

.interface_tab-panel__8HLa.interface_is-selected_sX9wX {
    display: block;
}

.interface_commits-container_L47R7 {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.interface_commit-link_Kr66c {
    text-decoration: none;
    color: inherit;
}

.interface_commit-item_Me2E8 {
    padding: 0.5rem;
    border: 0.0625rem solid var(--ui-black-transparent);
    border-radius: 0.5rem;
}

.interface_commit-item_Me2E8:hover {
    border-color: var(--looks-secondary);
}

.interface_commit-message_GzHID {
    font-weight: bold;
}

.interface_commit-version_ywNg3 {
    background-color: var(--motion-tertiary);
    color: var(--ui-white);
    border: 1px solid var(--ui-black-transparent);
    padding: 0.25rem 0.5rem;
    margin: auto;
    border-radius: 1rem;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
}

.interface_spinner_kLchm {
    display: flex;
    justify-content: center;
    align-items: center;
}

.interface_actions-grid_YaEbv {
    display: flex;
    flex-direction: column;
    border: 0.0625rem solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    padding: 0.5rem;
    gap: 0.5rem;
}

.interface_action-content_kiKJY {
    display: flex;
    align-items: flex-start;
    border: 0.0625rem solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    padding: 0.5rem;
    gap: 0.5rem;
}

.interface_action-avatar-container_jVwzv {
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
    min-height: 2rem;
}

.interface_action-avatar_Bt5Yx {
    border-radius: calc(0.5rem / 2);
}

.interface_action-date_kYI_8 {
    margin-left: auto;
    font-size: 0.875rem;
}

.interface_load-more-button_WlIvm {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 0.75rem 1rem;
    background: var(--looks-secondary);
    color: var(--ui-white);
    border: 1px solid var(--looks-secondary);
    font-weight: 600;
    font-size: 0.85rem;
    display: flex;
    justify-content: center;
}

.interface_description-field_ccK8S {
    box-sizing: border-box !important;
    width: 100% !important;
    height: 7.5rem !important;
    resize: none !important;
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
    border: 0.0625rem dashed var(--ui-black-transparent) !important;
    border-radius: 0.5rem !important;
    background-color: var(--project-title-inactive) !important;
    background-clip: padding-box;
    padding: 0.5rem !important;
}

.interface_description-field_ccK8S {
    color: var(--text-primary) !important;
    font-weight: bold !important;
    font-size: .8rem !important;
}

.interface_description-field_ccK8S::-ms-input-placeholder {
    color: var(--text-primary) !important;
    opacity: 0.8 !important;
    font-weight: normal !important;
    font-size: .8rem !important;
    font-style: italic !important;
}

.interface_description-field_ccK8S::placeholder {
    color: var(--text-primary) !important;
    opacity: 0.8 !important;
    font-weight: normal !important;
    font-size: .8rem !important;
    font-style: italic !important;
}

.interface_description-field_ccK8S:hover {
    background-color: var(--project-title-hover) !important;
    border-color: var(--ui-black-transparent) !important; /* dont use hover border from custom input */
}
`, "",{"version":3,"sources":["webpack://./src/playground/interface.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D,8FAA8F;;AAE9F;;;;;;IAMI,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;;;;;IAKI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;IACf,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mDAAmD;IACnD,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mDAAmD;IACnD,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,mDAAmD;IACnD,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,gBAAgB;;IAEhB,2DAA2D;IAC3D,gBAAgB;IAChB,kBAAkB;;IAElB,qCAAqC;IACrC,oBAAoB;IACpB,2BAA2B;;IAE3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;;IAEhB,sCAAsC;IACtC,6CAA6C;;IAE7C,2BAA2B;IAC3B,kBAAkB;;IAElB,oCAAoC;IACpC,yCAAyC;;IAEzC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,yBAAyB;;OAEtB,sBAAsB;;QAErB,qBAAqB;;YAEjB,iBAAiB;IACzB,mBAAmB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA,wCAAwC;;AAExC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA,qBAAqB;;AAErB;IACI,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,sBAAsB;IACtB,6CAA6C;IAC7C,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mDAAmD;IACnD,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mDAAmD;IACnD,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,2DAA2D;IAC3D,qBAAqB;IACrB,kCAAkC;IAClC,sBAAsB;IACtB,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;IAChC,+DAA+D;IAC/D,gCAAgC;IAChC,0DAA0D;IAC1D,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,uDAAuD;IACvD,oDAAoD,EAAE,4CAA4C;AACtG","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n/* Base styles used by Scratch https://github.com/LLK/scratch-www/blob/develop/src/main.scss */\n\nh1,\nh2,\nh3,\nh4,\nh5,\np {\n    margin: 0;\n    padding: 0;\n    border: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n    font-weight: bold;\n    line-height: 1.7em;\n}\n\nh1 {\n    font-weight: 2.5rem;\n}\n\nh2 {\n    font-weight: 2rem;\n}\n\nh3 {\n    font-size: 1.4rem;\n}\n\nh4 {\n    font-size: 1rem;\n}\n\na {\n    color: var(--link-color);\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    min-width: -webkit-fit-content;\n    min-width: -moz-fit-content;\n    min-width: fit-content;\n    background-color: var(--page-background);\n}\n\n.editor {\n    height: 100%;\n}\n\n.editor .center {\n    height: 100%;\n}\n\n.editor .wrapper-regulator {\n    height: 100%;\n}\n\n.player-only .center {\n    margin: 0px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.5rem;\n    background: var(--ui-primary);\n    margin: 0px;\n    padding: 0.5rem;\n    min-width: calc(100% - 1rem);\n}\n\n.main-section {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.section {\n    width: 480px;\n    background: var(--ui-white);\n    margin: 0px;\n    padding: 0.5rem;\n    border-radius: 0.5rem;\n    border: 0.0625rem solid var(--ui-black-transparent);\n}\n\n.project-related-container {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    flex: 0 0 auto;\n    order: 1;\n}\n\n.project-related-section {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n}\n\n.project-related-section[hidden] {\n    display: none;\n}\n\n.project-related-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.project-related-view-all {\n    display: inline-block;\n    color: var(--link-color);\n    cursor: pointer;\n    text-decoration: underline;\n    margin: 0;\n}\n\n.project-related-grid {\n    display: flex;\n    overflow-x: auto;\n    border: 0.0625rem solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    padding: 0.5rem;\n    gap: 0.5rem;\n}\n\n.project-related-card {\n    box-sizing: border-box;\n    border: 0.0625rem solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    overflow: hidden;\n    cursor: pointer;\n    background-color: var(--ui-secondary);\n    width: 12rem;\n    min-width: 12rem;\n    min-height: 12rem;\n}\n\n.project-related-studio-card {\n    box-sizing: border-box;\n    border: 0.0625rem solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    overflow: hidden;\n    cursor: pointer;\n    background-color: var(--ui-secondary);\n    width: 14rem;\n    min-width: 14rem;\n    min-height: 12rem;\n}\n\n.project-related-thumb-wrapper img {\n    aspect-ratio: 4 / 3;\n    width: 100%;\n    background: #f3f4f6;\n}\n\n.project-related-studio-thumb-wrapper img {\n    aspect-ratio: 3 / 2;\n    width: 100%;\n    background: #f3f4f6;\n}\n\n.project-related-info {\n    padding: 0.75rem;\n}\n\n.project-related-info h4 {\n    margin: 0 0 0.5rem 0;\n}\n\n.project-related-info p {\n    font-size: 0.85rem;\n    color: #4b5563;\n    margin: 0;\n}\n\n.project-credit {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.5rem;\n    width: calc(480px - 1rem);\n    padding: 0.75rem 1rem;\n    text-align: left;\n}\n\n.footer {\n    padding: 10px 0;\n    border-top: 2px solid var(--ui-black-transparent);\n}\n\n.footer a {\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.footer-content {\n    max-width: 600px;\n    margin: auto;\n}\n\n.footer-text {\n    text-align: center;\n    margin: 5px 0 10px 0;\n}\n\n.footer-columns {\n    display: flex;\n    justify-content: center;\n    justify-items: center;\n    flex-wrap: wrap;\n}\n\n.footer-section {\n    display: flex;\n    flex-direction: column;\n    width: 200px;\n    margin-bottom: 10px;\n}\n\n.footer-section > * {\n    margin-bottom: 10px;\n}\n\n.infobox {\n    line-height: 1.5em;\n    padding: 0.5rem;\n    margin: 5px 0 8px 0;\n    border-radius: 0.5rem;\n    border: 1px solid #b9d6ff;\n    background-color: #dbebff;\n}\n\n.infobox p {\n    margin: 4px 0;\n}\n\n.infobox a {\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.unshared-update {\n    border-color: #ff52526e;\n    background-color: #ff525240;\n}\n\n.tab-list {\n    display: flex;\n    align-items: flex-end;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n    padding: 0.25rem;\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-weight: 500;\n    font-size: 0.80rem;\n\n    /* Overrides for react-tabs styling */\n    margin: 0 !important;\n    border-bottom: 0 !important;\n\n    color: var(--text-primary);\n}\n\n.tab.is-disabled {\n    display: none;\n}\n\n.tab {\n    height: calc(2.25rem * 0.9);\n    margin-bottom: 0;\n\n    border-radius: 1rem 1rem 0.5rem 0.5rem;\n    border: 1px solid var(--ui-black-transparent);\n\n    padding: 0.125rem 1.25rem 0;\n    font-size: 0.75rem;\n\n    background-color: var(--ui-tertiary);\n    color: var(--ui-text-primary-transparent);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    -webkit-user-select: none;\n\n       -moz-user-select: none;\n\n        -ms-user-select: none;\n\n            user-select: none;\n    white-space: nowrap;\n}\n\n.tab:hover {\n  background-color: var(--ui-primary);\n}\n\n.tab.is-selected {\n    height: 2.25rem;\n    color: var(--looks-secondary);\n    background-color: var(--ui-white);\n}\n\n.tab img {\n    width: 1.375rem;\n    filter: grayscale(100%);\n}\n\n[dir=\"ltr\"] .tab img {\n    margin-right: 0.125rem;\n}\n\n[dir=\"rtl\"] .tab img {\n    margin-left: 0.125rem;\n}\n\n.tab.is-selected img {\n    filter: none;\n}\n\n/* Tab style overrides from react-tabs */\n\n.tab.is-selected:after {\n    display: none;\n}\n\n.tab.is-selected:focus {\n    outline: none;\n    box-shadow: none;\n    border-color: var(--ui-black-transparent);\n}\n\n.tab.is-selected:focus:after {\n    display: none;\n}\n\n/* Body of the tabs */\n\n.tabs {\n    width: calc(480px + 1rem + 0.125rem);\n    position: relative;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.tab-panel {\n    position: relative;\n    flex-grow: 1;\n    display: none;\n}\n\n.tab-panel.is-selected {\n    display: block;\n}\n\n.commits-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.commit-link {\n    text-decoration: none;\n    color: inherit;\n}\n\n.commit-item {\n    padding: 0.5rem;\n    border: 0.0625rem solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n}\n\n.commit-item:hover {\n    border-color: var(--looks-secondary);\n}\n\n.commit-message {\n    font-weight: bold;\n}\n\n.commit-version {\n    background-color: var(--motion-tertiary);\n    color: var(--ui-white);\n    border: 1px solid var(--ui-black-transparent);\n    padding: 0.25rem 0.5rem;\n    margin: auto;\n    border-radius: 1rem;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.actions-grid {\n    display: flex;\n    flex-direction: column;\n    border: 0.0625rem solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    padding: 0.5rem;\n    gap: 0.5rem;\n}\n\n.action-content {\n    display: flex;\n    align-items: flex-start;\n    border: 0.0625rem solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    padding: 0.5rem;\n    gap: 0.5rem;\n}\n\n.action-avatar-container {\n    width: 2rem;\n    height: 2rem;\n    min-width: 2rem;\n    min-height: 2rem;\n}\n\n.action-avatar {\n    border-radius: calc(0.5rem / 2);\n}\n\n.action-date {\n    margin-left: auto;\n    font-size: 0.875rem;\n}\n\n.load-more-button {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    padding: 0.75rem 1rem;\n    background: var(--looks-secondary);\n    color: var(--ui-white);\n    border: 1px solid var(--looks-secondary);\n    font-weight: 600;\n    font-size: 0.85rem;\n    display: flex;\n    justify-content: center;\n}\n\n.description-field {\n    box-sizing: border-box !important;\n    width: 100% !important;\n    height: 7.5rem !important;\n    resize: none !important;\n    white-space: pre-wrap !important;\n    word-wrap: break-word !important;\n    border: 0.0625rem dashed var(--ui-black-transparent) !important;\n    border-radius: 0.5rem !important;\n    background-color: var(--project-title-inactive) !important;\n    background-clip: padding-box;\n    padding: 0.5rem !important;\n}\n\n.description-field {\n    color: var(--text-primary) !important;\n    font-weight: bold !important;\n    font-size: .8rem !important;\n}\n\n.description-field::-ms-input-placeholder {\n    color: var(--text-primary) !important;\n    opacity: 0.8 !important;\n    font-weight: normal !important;\n    font-size: .8rem !important;\n    font-style: italic !important;\n}\n\n.description-field::placeholder {\n    color: var(--text-primary) !important;\n    opacity: 0.8 !important;\n    font-weight: normal !important;\n    font-size: .8rem !important;\n    font-style: italic !important;\n}\n\n.description-field:hover {\n    background-color: var(--project-title-hover) !important;\n    border-color: var(--ui-black-transparent) !important; /* dont use hover border from custom input */\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `interface_container_uYA1D`;
export var editor = `interface_editor_lI2gX`;
export var center = `interface_center_rSxMk`;
var _1 = `interface_wrapper-regulator_I3Lbn`;
export { _1 as "wrapper-regulator" };
export var wrapperRegulator = `interface_wrapper-regulator_I3Lbn`;
var _2 = `interface_player-only__MGmB`;
export { _2 as "player-only" };
export var playerOnly = `interface_player-only__MGmB`;
var _3 = `interface_main-section_wleeI`;
export { _3 as "main-section" };
export var mainSection = `interface_main-section_wleeI`;
export var section = `interface_section_sBMjS`;
var _4 = `interface_project-related-container_Fc4M5`;
export { _4 as "project-related-container" };
export var projectRelatedContainer = `interface_project-related-container_Fc4M5`;
var _5 = `interface_project-related-section_lOqHj`;
export { _5 as "project-related-section" };
export var projectRelatedSection = `interface_project-related-section_lOqHj`;
var _6 = `interface_project-related-header_gdRnc`;
export { _6 as "project-related-header" };
export var projectRelatedHeader = `interface_project-related-header_gdRnc`;
var _7 = `interface_project-related-view-all_crNoS`;
export { _7 as "project-related-view-all" };
export var projectRelatedViewAll = `interface_project-related-view-all_crNoS`;
var _8 = `interface_project-related-grid_dFhVB`;
export { _8 as "project-related-grid" };
export var projectRelatedGrid = `interface_project-related-grid_dFhVB`;
var _9 = `interface_project-related-card_sTCen`;
export { _9 as "project-related-card" };
export var projectRelatedCard = `interface_project-related-card_sTCen`;
var _a = `interface_project-related-studio-card_Fv3xX`;
export { _a as "project-related-studio-card" };
export var projectRelatedStudioCard = `interface_project-related-studio-card_Fv3xX`;
var _b = `interface_project-related-thumb-wrapper_rRgIV`;
export { _b as "project-related-thumb-wrapper" };
export var projectRelatedThumbWrapper = `interface_project-related-thumb-wrapper_rRgIV`;
var _c = `interface_project-related-studio-thumb-wrapper_IcQML`;
export { _c as "project-related-studio-thumb-wrapper" };
export var projectRelatedStudioThumbWrapper = `interface_project-related-studio-thumb-wrapper_IcQML`;
var _d = `interface_project-related-info_nDzrf`;
export { _d as "project-related-info" };
export var projectRelatedInfo = `interface_project-related-info_nDzrf`;
var _e = `interface_project-credit_NDLn6`;
export { _e as "project-credit" };
export var projectCredit = `interface_project-credit_NDLn6`;
export var footer = `interface_footer_dLhK2`;
var _f = `interface_footer-content_KvTod`;
export { _f as "footer-content" };
export var footerContent = `interface_footer-content_KvTod`;
var _10 = `interface_footer-text_kFpVx`;
export { _10 as "footer-text" };
export var footerText = `interface_footer-text_kFpVx`;
var _11 = `interface_footer-columns_tcZeb`;
export { _11 as "footer-columns" };
export var footerColumns = `interface_footer-columns_tcZeb`;
var _12 = `interface_footer-section_FdP5t`;
export { _12 as "footer-section" };
export var footerSection = `interface_footer-section_FdP5t`;
export var infobox = `interface_infobox_AbZXo`;
var _13 = `interface_unshared-update_wZeR8`;
export { _13 as "unshared-update" };
export var unsharedUpdate = `interface_unshared-update_wZeR8`;
var _14 = `interface_tab-list_wzzLc`;
export { _14 as "tab-list" };
export var tabList = `interface_tab-list_wzzLc`;
export var tab = `interface_tab_n50zb`;
var _15 = `interface_is-disabled_dSNZp`;
export { _15 as "is-disabled" };
export var isDisabled = `interface_is-disabled_dSNZp`;
var _16 = `interface_is-selected_sX9wX`;
export { _16 as "is-selected" };
export var isSelected = `interface_is-selected_sX9wX`;
export var tabs = `interface_tabs_cPLS6`;
var _17 = `interface_tab-panel__8HLa`;
export { _17 as "tab-panel" };
export var tabPanel = `interface_tab-panel__8HLa`;
var _18 = `interface_commits-container_L47R7`;
export { _18 as "commits-container" };
export var commitsContainer = `interface_commits-container_L47R7`;
var _19 = `interface_commit-link_Kr66c`;
export { _19 as "commit-link" };
export var commitLink = `interface_commit-link_Kr66c`;
var _1a = `interface_commit-item_Me2E8`;
export { _1a as "commit-item" };
export var commitItem = `interface_commit-item_Me2E8`;
var _1b = `interface_commit-message_GzHID`;
export { _1b as "commit-message" };
export var commitMessage = `interface_commit-message_GzHID`;
var _1c = `interface_commit-version_ywNg3`;
export { _1c as "commit-version" };
export var commitVersion = `interface_commit-version_ywNg3`;
export var spinner = `interface_spinner_kLchm`;
var _1d = `interface_actions-grid_YaEbv`;
export { _1d as "actions-grid" };
export var actionsGrid = `interface_actions-grid_YaEbv`;
var _1e = `interface_action-content_kiKJY`;
export { _1e as "action-content" };
export var actionContent = `interface_action-content_kiKJY`;
var _1f = `interface_action-avatar-container_jVwzv`;
export { _1f as "action-avatar-container" };
export var actionAvatarContainer = `interface_action-avatar-container_jVwzv`;
var _20 = `interface_action-avatar_Bt5Yx`;
export { _20 as "action-avatar" };
export var actionAvatar = `interface_action-avatar_Bt5Yx`;
var _21 = `interface_action-date_kYI_8`;
export { _21 as "action-date" };
export var actionDate = `interface_action-date_kYI_8`;
var _22 = `interface_load-more-button_WlIvm`;
export { _22 as "load-more-button" };
export var loadMoreButton = `interface_load-more-button_WlIvm`;
var _23 = `interface_description-field_ccK8S`;
export { _23 as "description-field" };
export var descriptionField = `interface_description-field_ccK8S`;
export default ___CSS_LOADER_EXPORT___;
